import * as React from "react";
import { Typography, Divider, Box } from "@samacare/design/core";
import { HelpTag } from "@samacare/layout/HelpTag";

export type EnrollmentSectionProps = {
  title: string;
  description?: string | React.ReactNode;
  adornment?: React.ReactNode;
  help?: string;
};

export const EnrollmentSection: React.FC<EnrollmentSectionProps> = ({
  title,
  description,
  adornment,
  children,
  help,
}) => (
  <Box minWidth={600}>
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Typography variant="h6" color="primary.main">
        {title}
        {help && <HelpTag text={help} />}
      </Typography>
      {adornment}
    </Box>
    <Divider />
    {description && (
      <Typography variant="body" mt={2}>
        {description}
      </Typography>
    )}
    <Box mt={description ? 2 : 3} mb={6}>
      {children}
    </Box>
  </Box>
);
